import { Injectable } from '@angular/core';

/**
 * Safe JSON read/write for browser storage (Qualys: localStorage misuse / unsafe parsing).
 */
@Injectable({ providedIn: 'root' })
export class SafeStorageService {
  getJson<T>(storage: Storage, key: string): T | null {
    const raw = storage.getItem(key);
    if (!raw) {
      return null;
    }

    try {
      const parsed = JSON.parse(raw) as T;
      if (parsed === null || typeof parsed !== 'object') {
        storage.removeItem(key);
        return null;
      }
      return parsed;
    } catch {
      storage.removeItem(key);
      return null;
    }
  }

  setJson(storage: Storage, key: string, value: unknown): void {
    storage.setItem(key, JSON.stringify(value));
  }

  remove(storage: Storage, key: string): void {
    storage.removeItem(key);
  }
}
